import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import _isEmpty from "lodash/isEmpty";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.is-array.js";
import "regenerator-runtime/runtime.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState, useRef } from 'react';
import { Button, ColorBatch, useUser } from 'components';
import { showApiError } from 'utils';
import { getPendingCommissionAmounts, sendRequestCommission, changeCommissionRequestStatus } from 'services';
import { REPORT_STATUS, reportStatusColorMap, reportStatusName } from 'enums';
import CommissionAmountsModal from './CommissionAmountsModal';
import { cardsContainer, card, cardHeader, cardBody, cardDivider, dataField, fieldLabel, fieldValue, amountValue, actionsWrap, emptyState } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var requested = REPORT_STATUS.requested,
    sent = REPORT_STATUS.sent,
    confirmed = REPORT_STATUS.confirmed,
    rejected = REPORT_STATUS.rejected;
var buttonTypes = {
  requested: {
    name: 'Заяви',
    type: 'info'
  },
  sent: {
    name: 'Изплати',
    type: 'warning'
  },
  confirmed: {
    name: 'Потвърди',
    type: 'success'
  },
  rejected: {
    name: 'Откажи',
    type: 'primary'
  }
};

var CommissionPaymentRequests = function CommissionPaymentRequests() {
  var _useUser = useUser(),
      userInfo = _useUser.userInfo,
      roleAdditionalData = _useUser.roleAdditionalData;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      pendingCommissionAmounts = _useState2[0],
      setPendingCommissionAmounts = _useState2[1];

  var amountModalRef = useRef();
  var isTenantManager = roleAdditionalData.isTenantManager,
      isFranchiseeOwner = roleAdditionalData.isFranchiseeOwner;
  useEffect(function () {
    fetchPendingCommissionAmounts();
  }, []);

  var fetchPendingCommissionAmounts = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _amountModalRef$curre;

      var _yield$getPendingComm, _yield$getPendingComm2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getPendingCommissionAmounts(_objectSpread({}, isFranchiseeOwner && {
                franchisee: userInfo === null || userInfo === void 0 ? void 0 : userInfo.franchisee_id
              }));

            case 2:
              _yield$getPendingComm = _context.sent;
              _yield$getPendingComm2 = _slicedToArray(_yield$getPendingComm, 2);
              res = _yield$getPendingComm2[0];
              err = _yield$getPendingComm2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              (_amountModalRef$curre = amountModalRef.current) === null || _amountModalRef$curre === void 0 ? void 0 : _amountModalRef$curre.close();
              setPendingCommissionAmounts(res);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchPendingCommissionAmounts() {
      return _ref.apply(this, arguments);
    };
  }();

  var handleSendRequestReport = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data, status, isRequest, isSentOrRequest) {
      var method, params, _yield$method, _yield$method2, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              method = isSentOrRequest ? sendRequestCommission : changeCommissionRequestStatus;
              params = isSentOrRequest ? [{
                franchisee_id: data === null || data === void 0 ? void 0 : data.franchisee_id,
                amount: isRequest ? data === null || data === void 0 ? void 0 : data.requested_base_amount : data === null || data === void 0 ? void 0 : data.future_base_amount,
                status: status
              }] : [data === null || data === void 0 ? void 0 : data.current_request_id, {
                status: status
              }];
              _context2.next = 4;
              return method.apply(void 0, params);

            case 4:
              _yield$method = _context2.sent;
              _yield$method2 = _slicedToArray(_yield$method, 2);
              err = _yield$method2[1];

              if (!err) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", showApiError(err));

            case 9:
              fetchPendingCommissionAmounts();

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSendRequestReport(_x, _x2, _x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();

  var reportButton = function reportButton(data, status, isRequest) {
    var config = buttonTypes[status];
    var isSentOrRequest = status === requested || status === sent && !isRequest;
    return ___EmotionJSX(Button, {
      small: true,
      type: config === null || config === void 0 ? void 0 : config.type,
      onClick: function onClick() {
        return isSentOrRequest ? handleOpenModal(data, status, isRequest, isSentOrRequest) : handleSendRequestReport(data, status, isRequest, isSentOrRequest);
      }
    }, config === null || config === void 0 ? void 0 : config.name);
  };

  var handleOpenModal = function handleOpenModal(data, status, isRequest, isSentOrRequest) {
    var _amountModalRef$curre2;

    return (_amountModalRef$curre2 = amountModalRef.current) === null || _amountModalRef$curre2 === void 0 ? void 0 : _amountModalRef$curre2.open({
      data: data,
      status: status,
      isRequest: isRequest,
      isSentOrRequest: isSentOrRequest
    });
  };

  var renderActionButton = function renderActionButton(data) {
    switch (true) {
      case isTenantManager && _isEmpty(data === null || data === void 0 ? void 0 : data.status):
        return (data === null || data === void 0 ? void 0 : data.future_base_amount) === '0.00' ? null : reportButton(data, sent, false);

      case isFranchiseeOwner && _isEmpty(data === null || data === void 0 ? void 0 : data.status):
        return (data === null || data === void 0 ? void 0 : data.future_base_amount) === '0.00' ? null : reportButton(data, requested, false);

      case isFranchiseeOwner && (data === null || data === void 0 ? void 0 : data.status) === requested:
        return reportButton(data, rejected);

      case isTenantManager && (data === null || data === void 0 ? void 0 : data.status) === requested:
        return ___EmotionJSX("div", {
          css: actionsWrap
        }, reportButton(data, rejected), reportButton(data, sent, true));

      case isFranchiseeOwner && (data === null || data === void 0 ? void 0 : data.status) === sent:
        return reportButton(data, confirmed);

      default:
        return null;
    }
  };

  if ((pendingCommissionAmounts === null || pendingCommissionAmounts === void 0 ? void 0 : pendingCommissionAmounts.length) === 0) return ___EmotionJSX("div", {
    css: emptyState
  }, "\u041D\u044F\u043C\u0430 \u043D\u0430\u043C\u0435\u0440\u0435\u043D\u0438 \u0437\u0430\u043F\u0438\u0441\u0438!");
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", {
    css: cardsContainer
  }, pendingCommissionAmounts === null || pendingCommissionAmounts === void 0 ? void 0 : pendingCommissionAmounts.map(function (el, i) {
    var _el$last_payment_date, _el$current_request_d, _el$current_sent_date;

    return ___EmotionJSX("div", {
      css: card,
      key: "".concat(el === null || el === void 0 ? void 0 : el.franchisee_name, "-").concat(i)
    }, ___EmotionJSX("div", {
      css: cardHeader
    }, ___EmotionJSX("span", {
      className: "card-name"
    }, el === null || el === void 0 ? void 0 : el.franchisee_name), ___EmotionJSX("div", {
      className: "card-header-right"
    }, (el === null || el === void 0 ? void 0 : el.status) && !_isEmpty(el === null || el === void 0 ? void 0 : el.status) && ___EmotionJSX(ColorBatch, {
      type: reportStatusColorMap[el === null || el === void 0 ? void 0 : el.status]
    }, reportStatusName[el === null || el === void 0 ? void 0 : el.status]), renderActionButton(el))), ___EmotionJSX("div", {
      css: cardBody
    }, ___EmotionJSX("div", {
      css: dataField
    }, ___EmotionJSX("span", {
      css: fieldLabel
    }, "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u043E \u0438\u0437\u043F\u043B\u0430\u0449\u0430\u043D\u0435"), ___EmotionJSX("span", {
      css: fieldValue
    }, (_el$last_payment_date = el === null || el === void 0 ? void 0 : el.last_payment_date) !== null && _el$last_payment_date !== void 0 ? _el$last_payment_date : '—')), ___EmotionJSX("div", {
      css: dataField
    }, ___EmotionJSX("span", {
      css: fieldLabel
    }, "\u0417\u0430\u044F\u0432\u0435\u043D\u043E \u0438\u0437\u043F\u043B\u0430\u0449\u0430\u043D\u0435"), ___EmotionJSX("span", {
      css: fieldValue
    }, (_el$current_request_d = el === null || el === void 0 ? void 0 : el.current_request_date) !== null && _el$current_request_d !== void 0 ? _el$current_request_d : '—')), ___EmotionJSX("div", {
      css: dataField
    }, ___EmotionJSX("span", {
      css: fieldLabel
    }, "\u041F\u043B\u0430\u0442\u0435\u043D\u043E \u043D\u0430"), ___EmotionJSX("span", {
      css: fieldValue
    }, (_el$current_sent_date = el === null || el === void 0 ? void 0 : el.current_sent_date) !== null && _el$current_sent_date !== void 0 ? _el$current_sent_date : '—')), ___EmotionJSX("div", {
      css: cardDivider
    }), ___EmotionJSX("div", {
      css: dataField
    }, ___EmotionJSX("span", {
      css: fieldLabel
    }, "\u0417\u0430\u044F\u0432\u0435\u043D\u0430 \u0441\u0443\u043C\u0430"), ___EmotionJSX("span", {
      css: amountValue
    }, el === null || el === void 0 ? void 0 : el.requested_base_amount, ___EmotionJSX("span", {
      className: "currency"
    }, el === null || el === void 0 ? void 0 : el.currency)), ___EmotionJSX("span", {
      css: fieldLabel
    }, "\u041A\u043E\u043C\u0438\u0441\u0438\u043E\u043D\u0430: ", el === null || el === void 0 ? void 0 : el.requested_commission_amount, " ", el === null || el === void 0 ? void 0 : el.currency)), ___EmotionJSX("div", {
      css: dataField
    }, ___EmotionJSX("span", {
      css: fieldLabel
    }, "\u041D\u0430\u0442\u0440\u0443\u043F\u0430\u043D\u0430 \u0441\u0443\u043C\u0430"), ___EmotionJSX("span", {
      css: amountValue
    }, el === null || el === void 0 ? void 0 : el.future_base_amount, ___EmotionJSX("span", {
      className: "currency"
    }, el === null || el === void 0 ? void 0 : el.currency)), ___EmotionJSX("span", {
      css: fieldLabel
    }, "\u041A\u043E\u043C\u0438\u0441\u0438\u043E\u043D\u0430: ", el === null || el === void 0 ? void 0 : el.future_commission_amount, " ", el === null || el === void 0 ? void 0 : el.currency))));
  })), ___EmotionJSX(CommissionAmountsModal, {
    ref: amountModalRef,
    onSubmit: function onSubmit(data) {
      return handleSendRequestReport(data === null || data === void 0 ? void 0 : data.data, data === null || data === void 0 ? void 0 : data.status, data === null || data === void 0 ? void 0 : data.isRequest, data === null || data === void 0 ? void 0 : data.isSentOrRequest);
    }
  }));
};

export default CommissionPaymentRequests;